import React, { useEffect, useState } from "react";
import UploadBanner from "../components/UploadBanner";
import SummaryApi from "../common";
import AdminBannerCard from "../components/AdminBannerCard";

const AllBanners = () => {
  const [openUploadBanner, setOpenUploadBanner] = useState(false);
  const [allBanners, setAllBanners] = useState([]);

  // Function to fetch all banners
  const fetchAllBanners = async () => {
    try {
      const response = await fetch(SummaryApi.getBanners.url);
      const dataResponse = await response.json();

      console.log("Fetched Banners:", dataResponse);

      setAllBanners(dataResponse?.data || []);
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    fetchAllBanners();
  }, []);

  return (
    <div>
      {/* Header */}
      <div className="bg-white py-2 px-4 flex justify-between items-center">
        <h2 className="font-bold text-lg">All Banners</h2>
        <button
          className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-all py-1 px-3 rounded-full"
          onClick={() => setOpenUploadBanner(true)}
        >
          Add Banner
        </button>
      </div>

      {/* Banners List */}
      <div className="flex items-center flex-wrap gap-5 py-4 h-[calc(100vh-190px)] overflow-y-auto">
        {allBanners.map((banner, index) => (
          <AdminBannerCard
            data={banner}
            key={index + "_banner"}
            fetchData={fetchAllBanners}
          />
        ))}
      </div>

      {/* Upload Banner Component */}
      {openUploadBanner && (
        <UploadBanner
          onClose={() => setOpenUploadBanner(false)}
          fetchData={fetchAllBanners}
        />
      )}
    </div>
  );
};

export default AllBanners;
